import {useDispatch} from "react-redux";
import {AppDispatch} from "../stores/authorizationStore";

export const useAppDispatch = () => useDispatch<AppDispatch>()
